import { render, staticRenderFns } from "./borrowingAnUmbrellaReturn.vue?vue&type=template&id=4618ec88&scoped=true&"
import script from "./borrowingAnUmbrellaReturn.vue?vue&type=script&lang=js&"
export * from "./borrowingAnUmbrellaReturn.vue?vue&type=script&lang=js&"
import style0 from "./borrowingAnUmbrellaReturn.vue?vue&type=style&index=0&id=4618ec88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618ec88",
  null
  
)

export default component.exports